import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Summary from './components/Summary'
import Tables from './components/Tables'

import hocConnect from './hocConnect'

@hocBlock(config.modules.report.key, { levelReload: true })
@hocConnect
export default class Grants extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        grantsTableChange: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        transformedData: PropTypes.object,
    }

    handleTableChange = (changeData) => {
        const { module, block, id, customData, level, grantsTableChange } = this.props

        grantsTableChange(module, block, id, level, customData, changeData)
    }

    render() {
        const { id, transformedData } = this.props

        return (
            <div className={'grants-block-container'}>
                <Summary data={transformedData || {}} />
                {!_.isEmpty(_.get(transformedData, 'grants', [])) && (
                    <Tables entityId={id} handleTableChange={this.handleTableChange} />
                )}
            </div>
        )
    }
}
